import React from 'react';
import useSWR from 'swr';
import type { DeviceTag } from '../../data/DeviceTag';
import { listDeviceTagFetcher } from '../../data/DeviceTag';
import { AxiosError } from 'axios';
import { Anchor, Breadcrumbs, Button, Paper, Skeleton, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const DeviceTagsList: React.FC = () => {
    const navigate = useNavigate();
    const {
        data: tags,
        isLoading,
        error,
    } = useSWR<DeviceTag[], AxiosError>('api/device-tags', listDeviceTagFetcher);

    if (isLoading) return <Skeleton height={120} />;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <div>
            <Breadcrumbs separatorMargin="xs" separator={<Text size="sm" fw={500}>/</Text>}>
                <Anchor size="sm" fw={500} onClick={() => navigate('/')}>
                    Home
                </Anchor>
                <Text size="sm">Device tags</Text>
            </Breadcrumbs>
            <h2>Device tags</h2>
            <Button onClick={() => navigate('/device-tags/new')} size="xs" style={{ marginBottom: '16px' }}>
                Add device tag
            </Button>
            {tags?.map(tag => (
                <Paper key={tag.id} shadow="xs" p="lg" style={{ marginBottom: '16px' }}>
                    <Anchor onClick={() => navigate(`/device-tag/${tag.id}`)}>{tag.label}</Anchor>
                </Paper>
            ))}
        </div>
    );
};

export default DeviceTagsList;
